import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';


class RetIslrCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false
        };
    }
    render() {
        let retIslr= this.props.retIslr;

        const tipo = ['', 'Factura', 'N/D', 'N/C'];

        return (
             <Card {...this.props}>
                <CardHeader
                title={retIslr.primaryText()}
                subtitle={<span>{retIslr.proveedor.name}<br />{moment(retIslr.fecha_retencion).format('DD-MM-YYYY')}</span>}
                actAsExpander={true}
                showExpandableButton={true}
                textStyle={{paddingRight:40}}
                />
                <CardText expandable={true} style={{padding:'8px 16px'}}>
                    <List >
                        <ListItem
                            disableTouchRipple={true}
                            innerDivStyle={{padding:1}}
                            primaryText={
      
                                <div style={{marginBottom:10}}>
                                    <div style={{marginBottom:5}}>
                                    <span>Tipo:</span>
                                    <span>{tipo[parseInt(retIslr.tipo_documento)]}</span>
                                    </div>
                                    <span>N°:{retIslr.numero_documento} | </span>
                                    <span>Retención: {parseFloat(retIslr.retencion()).fmtd()}</span>
                                </div>
                            }/>
                    </List>
                </CardText>
                <CardActions expandable={true}>
                    <FlatButton label="Descargar" primary={true} onTouchTap={this.props.handleDownload.bind(this, this.props.idx)} />
                    <FlatButton label="Editar"  onTouchTap={this.props.handleEdit.bind(this, this.props.idx)}/>
                    <FlatButton label="Eliminar" secondary={true} onTouchTap={() => {this.setState({modalOpen: true});}} />
                    
                </CardActions>

                <Dialog
                title="¿Desea Eliminar Este Registro?"
                actions={[
                    <FlatButton 
                        onTouchTap={() => {this.setState({modalOpen: false}); return this.props.handleDelete(this.props.idx);}} label="Eliminar"/>, 
                    <FlatButton 
                        label="No" 
                        onTouchTap={() => {this.setState({modalOpen: false});}}/>
                    ]}
                modal={true}
                open={this.state.modalOpen}
                />
            </Card>
        );
    }
}

export default RetIslrCard;


/** WEBPACK FOOTER **
 ** ./app-react/components/RetIslrCard.jsx
 **/